import './style.css'

export default class ImagePlaceholder {
    static selector = '.img-placeholder'

    constructor(block) {
        this.block = block
    }
}
